module.exports = __webpack_public_path__ + "static/media/capa-manager.a7105832.jpg";